import { defineComponent as _defineComponent } from 'vue'
import ViewLevelRow from '@/views/Automation/CampaignCreatorV2/components/ViewLevel/ViewLevelRow.ts.vue';
import { getContainerInlineStyles } from '@/views/Automation/CampaignCreatorV2/helpers';
import useAdStore from '@/views/Automation/CampaignCreatorV2/store/Ad';
import useAdAccountStore from '@/views/Automation/CampaignCreatorV2/store/AdAccount';
import useAdSetStore from '@/views/Automation/CampaignCreatorV2/store/AdSet';
import useCampaignStore from '@/views/Automation/CampaignCreatorV2/store/Campaign';
import useNavigationStore from '@/views/Automation/CampaignCreatorV2/store/Navigation';
import { Level, NavigationAction } from '@/views/Automation/CampaignCreatorV2/types';
import { storeToRefs } from 'pinia';
import { onBeforeUnmount, onErrorCaptured } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ViewLevelWrapper.ts',
  setup(__props) {

const navigationStore = useNavigationStore();
const navigationGetters = storeToRefs(navigationStore);

const campaignStore = useCampaignStore();
const adSetStore = useAdSetStore();
const adStore = useAdStore();

onBeforeUnmount(() => {
  const campaignId = navigationGetters.campaignInternalId.value;
  const campaign = navigationGetters.getNavigation.value.find((item) => item.id === campaignId);
  const firstAdsetForCampaign = campaign?.children?.[0];
  const firstAd = firstAdsetForCampaign?.children?.[0];
  navigationStore.setAdSetInternalId(firstAdsetForCampaign?.id);
  navigationStore.setAdInternalId(firstAd?.id);
});

onErrorCaptured((error) => {
  console.error('Error in ViewLevelWrapper', error);
});

function dispatchEvent(action: NavigationAction, level: Level) {
  switch (level) {
    case Level.Campaign:
      campaignStore.dispatch(action);
      break;
    case Level.AdSet:
      adSetStore.dispatch(action);
      break;
    case Level.Ad:
      adStore.dispatch(action);
      break;
  }
  campaignStore.updateAbGroups();
}

function changeNavigation(level: Level, campaignId: string, adsetId?: string, adId?: string) {
  campaignStore.updateAbGroups();
  const isCampaignMinSetupDone = useCampaignStore().isMinimumSetupDone();
  if (!isCampaignMinSetupDone) {
    return;
  }

  if (level === Level.AdSet) {
    useAdAccountStore().prepareAccount();
    adSetStore.getSuggestedVariables();
  }

  if (level === Level.Ad) {
    useAdAccountStore().prepareAccount();
    adStore.getSuggestedVariables();
  }

  navigationStore.onActiveSelect(level, campaignId, adsetId, adId);
}

return { __sfc: true,navigationStore, navigationGetters, campaignStore, adSetStore, adStore, dispatchEvent, changeNavigation, ViewLevelRow, getContainerInlineStyles, Level }
}

})